import { Injectable, inject } from '@angular/core';
import { SupabaseService } from './supabase.service';
import { AuthService } from './auth.service';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root'
})
export class CorrectionService {
  private supabase = inject(SupabaseService).client;
  private authService = inject(AuthService);
  private logService = inject(LogService);

  private isDemoMode(): boolean {
    const user = this.authService.currentUser();
    return !!user && user.id.startsWith('mock-user-id');
  }

  async reportCorrection(correctionId: number, reason: string): Promise<void> {
    if (this.isDemoMode()) {
      await this.logService.logInfo('Correction report simulated in demo mode', {
        correctionId,
        reason,
      });
      return;
    }
      
    const { error } = await this.supabase.rpc('report_correction', {
      p_correction_id: correctionId,
      p_reason: reason
    });
    
    if (error) {
      await this.logService.logError('Failed to report correction', error, {
        correctionId,
      });
      throw new Error('Failed to report correction.');
    }
  }
}
